module.exports = __webpack_public_path__ + "media/Video 62.0764d73a.mp4";